import { OrderDirection, SortOrder } from 'common/utils/commonTypes';
import { NotifyTimes, NotifyTimesVariables } from './__generated__/NotifyTimes';
import { TABLE_ROWS } from 'common/constants';
import { FilterArrayType } from 'common/components/Filters';
import { NotifyTimesOrderBy } from 'common/types/globalTypes';

type OrderLookup = {
  [direction in OrderDirection]: NotifyTimesOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'notifyType',
    {
      [OrderDirection.ASC]: ['NOTIFY_TYPE_BY_NOTIFY_TYPE_ID__DESCRIPTION_ASC'],
      [OrderDirection.DESC]: [
        'NOTIFY_TYPE_BY_NOTIFY_TYPE_ID__DESCRIPTION_DESC',
      ],
    },
  ],
  [
    'lastRun',
    {
      [OrderDirection.ASC]: ['LAST_RUN_ASC'],
      [OrderDirection.DESC]: ['LAST_RUN_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const defaultOrderBy: NotifyTimesOrderBy[] = [
    'SORT_ORDER_ASC',
    '_CREATED_DATE_ASC',
  ];

  if (!sort) return defaultOrderBy;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return Array.from(new Set([...(orderBy ? orderBy : []), ...defaultOrderBy]));
};

export const onHandleSearch = (
  showMore: boolean,
  sortOrderParam: SortOrder | undefined,
  notifyTimes: NotifyTimes | undefined
) => {
  const variables: NotifyTimesVariables = {
    first: TABLE_ROWS,
    orderBy: toOrderByVariable(sortOrderParam),
    after: showMore ? notifyTimes?.notifyTimes?.pageInfo.endCursor : undefined,
  };
  return {
    queryVariables: variables,
  };
};

export const notifyCycleFilterVariable = (
  filterList: FilterArrayType[] | undefined
) =>
  filterList?.map((filter) => {
    switch (filter.filterKey) {
      case 'notifyTypeId':
        return {
          [filter.filterKey]: {
            equalTo: filter.value,
          },
        };
      default:
        return undefined;
    }
  });
